import request from '../../utils/request';

export function RegisterVerifyEmail(params) {
  return request({
    url: '/users/verify_email',
    method: 'post',
    data: params,
  });
}

export function userVerifyResend(params) {
  return request({
    url: '/emails/verify/resend',
    method: 'post',
    data: params,
  });
}

export function userForGetPassword(params) {
  return request({
    url: '/emails/password/forget',
    method: 'post',
    data: params,
  });
}
